import React, { useState, useEffect } from 'react';
import ReactCountryFlag from "react-country-flag"


export default function PlayerFlag(props) {
    const [twoLetterCode, setTwoLetterCode] = useState(props.code);
    const [country, setCountry] = useState("");
    const getCountryISO2 = require("country-iso-3-to-2");
    const countryLookup = require('country-code-lookup')

    useEffect(() => {
        async function fetchData() {
            var l3 = props.code;
            if (l3 === 'PAR')
                l3 = 'PRY';
            if (l3 === 'NED')
                l3 = 'NLD';
            if (l3 === 'IRI')
                l3 = 'IRN';
            if (l3 === 'VIE')
                l3 = 'VNM';
            if (l3 === 'BUL')
                l3 = 'BGR';
            if (l3 === 'GER')
                l3 = 'DEU';
            //if (l3 === '')
            //    l3 = '';
            //if (l3 === '')
            //    l3 = '';
            const l2 = getCountryISO2(l3);
            await setTwoLetterCode(l2);
            const countryObj = countryLookup.byIso(twoLetterCode)
            setCountry(countryObj?.country);
        }
        fetchData();
    }, []); //Runs only on the first render

        return (
            <div >
                <ReactCountryFlag
                    countryCode={twoLetterCode}
                    svg
                    style={{
                        width: '2em',
                        height: '2em',
                    }}
                    title={country}
                />
            </div>
            )
}